module.exports = "/_next/static/images/ae593d641689f40b30a2f40a75dc1d85-payment_bills_list.png";